export default __webpack_public_path__ + "static/media/google-play.746946bd.png";